const $ = window.jQuery; // slick-carousel is a jQuery plugin in legacy.js
import stage_language from './stage-language';
import Mustache from 'mustache';

const listTemplate = `
{{#items}}
  {{#isLift}}
    {{> advertisementCard }}
  {{/isLift}}
  {{^isLift}}
    {{> vehicleCard }}
  {{/isLift}}
{{/items}}
`;
const partials = {
  vehicleCard: document.getElementById('car-card-template')?.innerHTML || '',
  pictureSource: document.getElementById('mustache-vehicle-list-picturesource')?.innerHTML || '',
};

// This all is litlle stubit...
// dots and arrows are commented becouse not sure if they are needed or is there carousel witch need them
// shuold rewrite all...
const slickSettings = {
  lazyLoad: 'ondemand',
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  accessibility: true,
  responsive: [
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        //dots: true,
        //arrows: true,
      }
    },{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        // dots: true,
        //arrows: false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //dots: true,
        //arrows: false,
      }
    }
  ]
};

/* initialize slick carousel */
$('.cars-container #car-card-list').slick(slickSettings);

/* Functionality for filter buttons */
$('#car-carousel-filter-buttons button:first').addClass('selected');

$('#car-carousel-filter-buttons button').click(function(e){
  $('#car-carousel-filter-buttons button').removeClass('selected');
  $(e.target).addClass('selected');

  const filterText = $(e.target)[0].innerText ? $(e.target)[0].innerText.split(' ') : null;

  if (Array.isArray(filterText) && filterText.length >= 2) {
    $('.cars-container h2').html('<span class="strong">' + filterText.shift() + '</span> ' + filterText.join(' '));
  }

  let category = (e.target.dataset.filters === 'new-cars') ? 'uudet-autot' : '';
  let order = 'pid_desc';

  if(e.target.dataset.filters === 'just-added-cars'){
    category = 'vaihtoautot';
    order = 'pid_desc';
  } else if (e.target.dataset.filters === 'popular-cars'){
    order = 'views_desc'
  }

  const searchFilters = {
    order: order,
    category: category,
    getLifts: false,
    'stage-language': stage_language
  };

  $.ajax({
    url: '/stage-ajax/getVehicles',
    method: 'GET',
    data: JSON.parse(JSON.stringify(searchFilters)),
    dataType: 'json',
    success: function(response) {
      $('#frontpage-cars-container #car-card-list').slick('unslick');
      $('#car-card-list').html(Mustache.render(listTemplate, response, partials));
      $('#frontpage-cars-container #car-card-list').slick(slickSettings);
    }
  });
});

const brantPageFilterButtons = $('#brand-car-carousel-filter-buttons button');

brantPageFilterButtons.click((e) => {
  brantPageFilterButtons.removeClass('selected');
  $(e.target).addClass('selected');

  const filterText = $(e.target)[0].innerText ? $(e.target)[0].innerText.split(' ') : null;

  if (Array.isArray(filterText) && filterText.length >= 2) {
    $('.cars-container h2').html('<span class="strong">' + filterText.shift() + '</span> ' + filterText.join(' '));
  } else {
    $('.cars-container h2').html('<span class="strong">' + $(e.target)[0].innerText + '</span> ');
  }

  let category;

  if(e.target.dataset.filters === 'used-cars'){
    category = 'vaihtoautot';
  } else if(e.target.dataset.filters === 'demo-cars'){
    category = 'esittelyautot';
  } else if(e.target.dataset.filters === 'new-cars'){
    category = 'uudet-autot';
  }

  const searchFilters = {
    order: 'pid_desc',
    category: category,
    make: e.target.dataset.make,
    getLifts: false,
    'stage-language': stage_language,
    carType: e.target.dataset.cartype
  };

  $.ajax({
    url: '/stage-ajax/getVehicles',
    method: 'GET',
    data: JSON.parse(JSON.stringify(searchFilters)),
    dataType: 'json',
    success: function(response) {
      $('#car-card-list').slick('unslick');
      $('#car-card-list').html(Mustache.render(listTemplate, response, partials));
      $('#car-card-list').slick(slickSettings);
    }
  });
});
